import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class OtaRateProgramsService {

    getOtaRatePrograms(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_OTA_RATE_PROGRAMS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putOtaRatePrograms(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_OTA_RATE_PROGRAMS
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        const formData = data.formData
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(formData) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new OtaRateProgramsService()